import { gallerySectionTwo } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import React, { useState } from "react";
// import Masonry from "react-masonry-component";
import GalleryItem from "./GalleryItem";
import WeDOSectionItSol from "components/WeDOSection/WeDOSectionItSol";
import MansonryLoader from "components/MansonryLoader/MansonryLoader";
import { useAppStore } from "lib/store";
import { Box, ImageList } from "@mui/material";

const masonryOptions = {
  transitionDuration: 500,
};

const { title, tabBtns, items } = gallerySectionTwo;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;

const GallerySectionTwo = ({ portfolio = false, similar = false }) => {
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");
  const { loading, error, bountyCreative } = useAppStore();

  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="sec-title centered">
          <h2>
            Branding & Advertisement
            <span className="dot">.</span>
          </h2>
        </div>
        <WeDOSectionItSol />

          <Box sx={{ width: '100%', height: 450, overflowY: 'scroll' }}>
            <ImageList variant="masonry" cols={3} gap={8}>
              {Array(bountyCreative.total).fill(0).slice(0, Array(bountyCreative.total).length).map((item, index) => (
                index != 0 && <MansonryLoader
                  key={`${bountyCreative.title}-${index}`}
                  title={bountyCreative.title}
                  count={index}
                  path={bountyCreative.path}
                  alt='Bounty-Creative' />
              ))}
            </ImageList>
          </Box>

      </div>
    </section>
  );
};

export default GallerySectionTwo;
